import { request } from '@aqx-core/common/request';

import {
  IHideSignalCategoriesParams,
  ISignal,
  ISignalCategoriesResult,
  ISignalDetails,
  ISignalDetailsParams
} from '../model';

export default {
  all: () => request.get<ISignal[]>('/api/plugin/v1/signals'),
  hide: (params: IHideSignalCategoriesParams) => request.post('/api/plugin/v1/signals/hide', params),
  categories: () => request.get<ISignalCategoriesResult>('/api/plugin/v1/signals/categories'),
  favourites: () => request.get<ISignal[]>('/api/plugin/v1/signals/favourite'),
  getDetails: (params: ISignalDetailsParams) => request.get<ISignalDetails>('/api/plugin/v1/signals/detail', { params })
};
